import { frontendURL } from '../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
  CONTACT_PERMISSIONS,
  PORTAL_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import SearchView from './components/SearchView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/search/:tab?'),
    name: 'search',
    meta: {
      permissions: [
        ...ROLES,
        ...CONVERSATION_PERMISSIONS,
        CONTACT_PERMISSIONS,
        PORTAL_PERMISSIONS,
      ],
      // ACESSO-01 (L8b): a busca de conversas e mensagens pede o `conversations:participating`, e a de contatos, o
      // `contacts:read` (`search#index`, `#contacts`): basta um. A de artigos é de todo membro, mas a central de
      // ajuda é da plataforma, e sem os outros dois a busca não serve.
      escopos: ['conversations:participating', 'contacts:read'],
    },
    component: SearchView,
  },
];
